var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAttachment = function SvgAttachment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0788 8.59408L9.18625 15.4866C8.34187 16.331 7.19664 16.8053 6.0025 16.8053C4.80836 16.8053 3.66314 16.331 2.81875 15.4866C1.97437 14.6422 1.5 13.497 1.5 12.3028C1.5 11.1087 1.97437 9.96346 2.81875 9.11908L9.71125 2.22658C10.2742 1.66366 11.0377 1.34741 11.8338 1.34741C12.6298 1.34741 13.3933 1.66366 13.9563 2.22658C14.5192 2.7895 14.8354 3.55299 14.8354 4.34908C14.8354 5.14517 14.5192 5.90866 13.9563 6.47158L7.05625 13.3641C6.77479 13.6455 6.39305 13.8037 5.995 13.8037C5.59696 13.8037 5.21521 13.6455 4.93375 13.3641C4.65229 13.0826 4.49417 12.7009 4.49417 12.3028C4.49417 11.9048 4.65229 11.523 4.93375 11.2416L11.3013 4.88158",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAttachment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/attachment.dc2b7e53.svg";
export { ForwardRef as ReactComponent };